import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/content";

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative bg-black py-24 md:py-32 border-t border-white/10" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="mb-12 md:mb-16 max-w-2xl"
        >
          <p className="mb-6 text-xs uppercase tracking-mega text-gold">Owners Talk</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl text-white tracking-tight leading-[0.95]">
            Trusted on the water
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="flex flex-col border border-white/10 bg-white/[0.02] p-8 md:p-10"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={28} className="text-gold/70" />
              <blockquote className="mt-6 flex-1 text-lg font-light text-white/85 leading-relaxed">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 text-gold font-serif">
                  {t.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-white text-sm">{t.name}</span>
                  <span className="block text-white/40 text-xs tracking-wide">{t.detail}</span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
